<template>
  <div>
    <v-card v-if="Loading" color="yellow lighten-2">
      <v-card-text>
        <h3>Cargando</h3>
        <h3>Por Favor Espere...</h3>
      </v-card-text>
      <v-overlay>
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-card>
    <v-card :color="fondoEstado" v-if="!Loading && !InternacionEnCurso">
      <v-app-bar color="cyan lighten-4" dense elevation="0">
        <v-toolbar-title>Nueva Internacion </v-toolbar-title>
      </v-app-bar>
      <v-card-text>
        <v-row>
          <v-col md="9">
            <v-card class="my-1" color="teal lighten-4" elevation="4">
              <v-row>
                <v-col class="ml-2" md="2">
                  <v-text-field
                    style="max-width: 220px;"
                    type="date"
                    dense
                    hide-details
                    outlined
                    label="Fecha Inicio Internación"
                    v-model="internacion.fechainicio"
                    clearable
                  >
                  </v-text-field>
                </v-col>
                <v-col md="1">
                  <v-text-field
                    dense
                    hide-details
                    outlined
                    label="Días"
                    v-mask="'###'"
                    v-model.number="internacion.cantidadDias"
                  ></v-text-field>
                </v-col>
                <v-col md="5">
                  <cboSector v-model="internacion.id_sector"> </cboSector>
                </v-col>
                <v-col md="3">
                  <v-checkbox
                    v-model="rechazar"
                    label="Rechazar automáticamente" v-if="!efectorlogueado"
                  >
                  </v-checkbox>
                  <Combo
                    id_estado="4"
                    v-if="rechazar"
                    v-model="autorizacion.id_motivo"
                  />
                </v-col>
              </v-row>
            </v-card>
            <v-card class="my-1" elevation="4">
              <v-col class="light-blue lighten-4">
                Diagnostico:
                <span class="pl-6" v-if="diagnostico">
                  {{ diagnostico.Problema }}
                  <v-btn icon>
                    <v-icon color="red" @click="diagnostico = undefined">
                      mdi-delete
                    </v-icon>
                  </v-btn>
                </span>
              </v-col>
              <v-card-text v-if="!diagnostico">
                <v-row no-gutters>
                  <v-col md="6">
                    <AutocompletarDiagnostico
                      v-model="diagnostico"
                      v-if="!diagnostico"
                    ></AutocompletarDiagnostico>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
            <v-card class="my-1" elevation="4">
              <v-col class="light-blue lighten-4">
                Prescriptor
                <span class="pl-6" v-if="prescriptor">
                  {{ prescriptor.nombreefector }} ({{ prescriptor.RAZON_SOCI }})
                  <v-btn icon>
                    <v-icon color="red" @click="prescriptor = undefined">
                      mdi-delete
                    </v-icon>
                  </v-btn>
                </span>
              </v-col>
              <v-card-text v-if="!prescriptor">
                <v-row no-gutters>
                  <v-col md="12">
                    <busquedaefector v-model="prescriptor"></busquedaefector>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
            <v-card class="my-1" elevation="4">
              <v-col class="teal lighten-4">
                Prestador 
                <v-btn color="secondary" x-small dark depressed v-if="!efectorlogueado"
                  @click="traerSinEfector()"
                >Sin prestador</v-btn>
                <span class="pl-6" v-if="efector">
                  {{ efector.nombreefector }} ({{ efector.RAZON_SOCI }})
                  <v-btn icon>
                    <v-icon color="red" @click="efector = undefined">
                      mdi-delete
                    </v-icon>
                  </v-btn>
                  <domicilio
                    :id_efector="efector.Id"
                    v-model="autorizacion.id_domicilioprofesional"
                  ></domicilio>
                </span>
              </v-col>
              <v-card-text v-if="!efector">
                <v-row no-gutters>
                  <v-col md="12">
                    <busquedaefector
                      :id_plan="id_plan"
                      v-model="efector"
                    ></busquedaefector>
                    <busquedaefectorProvincia
                      :id_plan="id_plan"
                      v-model="efector"
                    ></busquedaefectorProvincia>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>

            <v-card class="my-1" elevation="4">
              <v-col class="light-blue lighten-4">
                <v-row>
                  <v-col md="6">
                    <v-text-field
                      label="Observacion"
                      class="ml-2"
                      background-color="grey lighten-3"
                      v-if="!readonly"
                      dense
                      hide-details
                      outlined
                      v-model="nuevaObservacion"
                      clearable
                    ></v-text-field>
                  </v-col>
                  <v-col md="6">
                    <v-text-field
                      label="Observacion Interna"
                      class="ml-2"
                      background-color="grey lighten-3"
                      v-if="!readonly && !efectorlogueado"
                      dense
                      hide-details
                      outlined
                      v-model="nuevaObservacionInterna"
                      clearable
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-card>
          </v-col>
          <v-col md="3">
            <Imagenes :IdImagenes="autorizacion.idimagenes"></Imagenes>
            <desestimar
              v-model="autorizacion.desestimarpatologias"
              :patologias="patologias"
            ></desestimar>
            <v-btn
              small
              class="green"
              :disabled="guardarDisable()"
              @click="Guardar()"
            >
              Guardar
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card :color="fondoEstado" v-if="!Loading && InternacionEnCurso">
      <h2>Internacion En Curso</h2>
      <Practica
        readonly
        :modificaInternacion="modificaInternacion"
        :solic="InternacionEnCurso"
        @guardado="$emit('guardado')"
      ></Practica>
    </v-card>
  </div>
</template>

<script>
import { mask } from 'vue-the-mask'
import Practica from '@/components/Practica/Practica'
import AutocompletarDiagnostico from '@/components/Diagnostico/Autocompletar'
import AutocompletarNomenclador from '@/components/Nomenclador/Autocompletar'
import busquedaefector from '@/components/Efectores/Autocomplete'
import busquedaefectorProvincia from '@/components/Efectores/PorProvincia'
import Imagenes from '@/components/Practica/Imagenes'
import cboSector from '@/components/Sectores/Combo'
import domicilio from '@/components/Efectores/Domicilios'
import desestimar from '@/components/Patologias/Desestimar'
import Combo from '@/components/Motivos/Combo'
import { mapActions, mapMutations, mapState } from 'vuex'
import LUM from '@/lib/LUM'
import API from '@/lib/API'

const ID_PRACTICA = process.env.VUE_APP_ID_PRACTICA_INTERNACION

export default {
  directives: { mask },
  props: {
    id_afiliado: Number,
    id_plan: Number,
    patologias: Array,
    readonly: {
      type: Boolean,
      default: false,
    },
    efectorlogueado: {
      type: Object,
      default: null,
    },
    modificaInternacion: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      rechazar: false,
      Loading: false,
      motivoEstado: '',
      diagnostico: undefined,
      efector: undefined,
      prescriptor: undefined,
      nuevaObservacion: '',
      nuevaObservacionInterna: '',
      autorizacion: {
        id_solic: 0,
        id_afiliado: 0,
        fechaprescripcion: '',
        fechaprogramada: '',
        idproblema: 0,
        problema: '',
        id_practica: ID_PRACTICA,
        cantidad: 1,
        id_efector: 0,
        id_efectorprofesional: 0,
        id_prescriptor: 0,
        tipo: 3,
        estado: 0,
        idimagenes: 0,
        id_domicilioprofesional: 0,
        desestimarpatologias: false,
      },
      internacion: {
        id: 0,
        id_solic: 0,
        fechainicio: '',
        id_sector: 0,
        cantidadDias: 1,
      },
    }
  },
  computed: {
    ...mapState('internaciones', ['InternacionEnCurso']),
    ...mapState('imagenespracticas', { listadocumentos: 'Lista' }),
    estado() {
      let ret = 'Sin Evaluar'
      switch (this.autorizacion.estado) {
        case 1:
          ret = 'Pendiente'
          break
        case 2:
          ret = 'Autorizado'
          break
        case 3:
          ret = 'En Gestion'
          break
        case 4:
          ret = 'Rechazado'
          break
        case 5:
          ret = 'Cerrado'
          break
        default:
          break
      }
      return ret
    },
    fondoEstado() {
      let ret = 'lime lighten-4'
      switch (this.autorizacion.estado) {
        case 1:
          ret = 'red'
          break
        case 2:
          ret = 'green'
          break
        case 3:
          ret = 'blue'
          break
        case 4:
          ret = 'black'
          break
        case 5:
          ret = 'white'
          break
        default:
          break
      }
      return ret
    },
    autorizacion_cantidad() {
      return this.autorizacion.cantidad
    },
    hoy() {
      return LUM.datetoYYYYMMDD(new Date())
    },
    autorizacion_fechaprescripcion() {
      return this.autorizacion.fechaprescripcion
    },
  },
  methods: {
    ...mapMutations('comun', ['mostrar']),
    ...mapActions('autorizaciones', ['modificarEntidad']),
    ...mapActions('internaciones', [
      'modificarInternacion',
      'traerInternacionEnCurso',
    ]),
    evaluarCantidad() {
      if (!this.autorizacion.cantidad) {
        this.autorizacion.cantidad = 1
        this.evaluarEstado()
      }
    },
    OKImagenes() {
      let ret = true
      if (this.listadocumentos.length === 0) {
        console.error('error en Imagenes')
        ret = false
      }
      return ret
    },
    OKFechaInicio() {
      let ret = true
      if (!this.internacion.fechainicio) {
        console.error('error en fecha de inicio')
        ret = false
      }
      return ret
    },
    OKSector() {
      let ret = true
      if (this.internacion.id_sector == 0) {
        console.error('error en el sector')
        ret = false
      }
      return ret
    },
    OKDiagnostico() {
      let ret = true
      if (!this.diagnostico) {
        console.error('error en el diagnostico')
        ret = false
      } else {
        if (this.diagnostico.IdProblema == 0) {
          console.error('error en el diagnostico')
          ret = false
        }
      }
      return ret
    },
    guardarDisable() {
      let ret = false
      if (
        !this.OKFechaInicio() ||
        !this.OKImagenes() ||
        !this.OKDiagnostico() ||
        !this.OKSector()
      ) {
        ret = true
      }
      return ret
    },
    async Guardar() {
      this.Loading = true
      let nuevaauto = await this.modificarEntidad(this.autorizacion)
      this.internacion.id_solic = nuevaauto.id_solic
      await this.modificarInternacion(this.internacion)
      if (this.nuevaObservacion) {
        await API.Observaciones.alta({
          id: 0,
          id_solic: nuevaauto.id_solic,
          observacion: this.nuevaObservacion,
          id_usuario: 0,
        })
      }
      if (this.nuevaObservacionInterna) {
        await API.ObservacionesInternas.alta({
          id: 0,
          id_solic: nuevaauto.id_solic,
          observacion: this.nuevaObservacionInterna,
          id_usuario: 0,
        })
      }
      this.resetear()
      this.Loading = false
      this.traerInternacionEnCurso(this.id_afiliado)
      this.$emit('practicaGuardada')
    },
    async traerSinEfector() {
      this.efector = await API.Efector.traerUno(1)
    },
    resetear() {
      this.motivoEstado = ''
      this.diagnostico = undefined
      this.efector = undefined
      this.prescriptor = undefined
      this.efectorprofesional = undefined
      this.autorizacion.id_solic = 0 //autorizacion= {
      //this.autorizacion.id_afiliado = 0;
      this.autorizacion.fechaprescripcion = ''
      this.autorizacion.fechaprogramada = ''
      this.autorizacion.idproblema = 0
      this.autorizacion.problema = ''
      this.autorizacion.id_practica = ID_PRACTICA
      this.autorizacion.cantidad = 1
      this.autorizacion.id_efector = 0
      this.autorizacion.id_efectorprofesional = 0
      this.autorizacion.id_prescriptor = 0
      this.autorizacion.tipo = 3
      this.autorizacion.estado = 0
      this.autorizacion.idimagenes = new Date().getTime()
      this.autorizacion.desestimarpatologias = false
      this.internacion.id_solic = 0
      this.internacion.fechainicio = ''
      this.internacion.id_sector = 0
      this.nuevaObservacion = ''
      this.nuevaObservacionInterna = ''
      this.autorizacion.id_domicilioprofesional = 0

      //};
    },
    async evaluarEstado() {
      if (this.rechazar) {
        this.autorizacion.estado = 4
        this.motivoEstado = ''
      } else if (
        this.autorizacion.id_afiliado &&
        this.autorizacion.cantidad &&
        this.autorizacion.id_practica &&
        this.autorizacion.id_efector
      ) {
        let estado = await API.Autorizaciones.evaluarEstado(
          this.autorizacion.id_afiliado,
          this.autorizacion.cantidad,
          this.autorizacion.id_practica,
          this.autorizacion.id_efector,
          this.autorizacion.id_efectorprofesional
        )
        this.autorizacion.estado = estado.idEstado
        this.motivoEstado = estado.motivo
      }
    },
  },
  components: {
    Practica,
    AutocompletarDiagnostico,
    AutocompletarNomenclador,
    busquedaefector,
    busquedaefectorProvincia,
    cboSector,
    domicilio,
    desestimar,
    Imagenes,
    Combo,
  },
  watch: {
    autorizacion_fechaprescripcion() {
      if (this.autorizacion_fechaprescripcion) {
        if (this.autorizacion_fechaprescripcion > this.hoy) {
          this.autorizacion.fechaprescripcion = ''
          //this.autorizacion.fechaprescripcion = '2000-01-01';
          //this.mostrar("La fecha de prescripcion no puede ser mayor a hoy " + this.hoy);
        }
      }
    },
    // IdImagenes() {
    //   if (this.IdImagenes) {
    //     this.autorizacion.idimagenes = this.IdImagenes;
    //   }
    // },
    id_afiliado() {
      if (this.id_afiliado) {
        this.autorizacion.id_afiliado = this.id_afiliado
        this.traerInternacionEnCurso(this.id_afiliado)
      }
    },
    diagnostico() {
      if (this.diagnostico) {
        this.autorizacion.idproblema = this.diagnostico.IdProblema
        this.autorizacion.problema = this.diagnostico.Problema
      }
    },
    efector() {
      if (this.efector) {
        this.autorizacion.id_efector = this.efector.Id
        this.evaluarEstado()
      }
    },
    prescriptor() {
      if (this.prescriptor) {
        this.autorizacion.id_prescriptor = this.prescriptor.Id
      }
    },
    efectorlogueado() {
      if (this.efectorlogueado) {
        this.efector = this.efectorlogueado
      }
    },
    rechazar() {
      this.evaluarEstado()
    },
  },
  mounted() {
    //this.autorizacion.idimagenes = this.IdImagenes;
    this.autorizacion.idimagenes = new Date().getTime()
    this.autorizacion.id_afiliado = this.id_afiliado
    this.traerInternacionEnCurso(this.id_afiliado)
    if (this.efectorlogueado) {
      this.efector = this.efectorlogueado
    }
  },
}
</script>

<style></style>
